"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MileageUnit = void 0;
/**
 * The possible units of vehicle mileage.
 *
 * *Swagger Schema Reference :* `MileageUnit`
 */
var MileageUnit;
(function (MileageUnit) {
    /**
     * Kilometers.
     */
    MileageUnit["KM"] = "km";
    /**
     * Miles.
     */
    MileageUnit["MILES"] = "miles";
})(MileageUnit = exports.MileageUnit || (exports.MileageUnit = {}));
//# sourceMappingURL=entityTypes.js.map